var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangleIcon, Label, Tooltip, TooltipTrigger, translate, useTooltip, } from '@lucidlink/uicore';
import { FileBrowserTestIdFactory } from '../interactions';
export const RemoteUploadIncomplete = ({ entryId, }) => {
    _react_refresh_temp_2();
    const { isTooltipActive, tooltipProps, triggerProps } = useTooltip({
        placement: 'right',
    });
    return (_jsxs(TooltipTrigger, { triggerProps: triggerProps, children: [_jsx(Label, { color: "static_alert", "data-testid": FileBrowserTestIdFactory.getEntryIncompleteTestId(entryId), StartIcon: AlertTriangleIcon, text: translate('Incomplete') }), isTooltipActive && (_jsx(Tooltip, { contents: [
                    translate('Another user started uploading or modifying the file but either went idle or had a slow upload, potentially leaving it incomplete.'),
                ], tooltipProps: tooltipProps }))] }));
};
_react_refresh_temp_1 = RemoteUploadIncomplete;
$RefreshReg$(_react_refresh_temp_1, "RemoteUploadIncomplete");
_react_refresh_temp_2(RemoteUploadIncomplete, "6Z9hKiQbkXe/L4MlJ1mOoLfPqrI=", false, () => [useTooltip]);
